/* eslint-disable no-restricted-globals */
import { defineStore } from 'pinia'
import { ref, inject } from 'vue'
import axios from 'axios'
import { useRouter } from 'vue-router'

export const useAuthStore = defineStore('auth', () => {
  const baseUrl = inject('baseUrl')

  const token = ref('')
  const phoneNumber = ref('')
  const password = ref('')

  const router = useRouter()

  const setToken = (newToken) => {
    token.value = newToken
    localStorage.setItem('token', newToken)
    axios.defaults.headers.common.Authorization = `Bearer ${newToken}`
  }

  const login = () => {
    axios.post(`${baseUrl}/api/frontend/auth/login`, { phoneNumber: phoneNumber.value, password: password.value })
      .then((r) => {
        setToken(r.data.accessToken)
        router.push({ name: 'app' })
      })
  }

  const logout = () => {
    localStorage.removeItem('token')
    location.reload()
  }

  return {
    token,
    phoneNumber,
    password,
    login,
    logout,
    setToken,
  }
})
